import { ReactElement } from 'react';

import { Dropdown, LocationBackState, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { PatientFileLocationData } from './common/common.types';
import { patientTranslationKeys } from './translations';

type GoToPatientFileLocationData = Record<string, unknown>;
type GoToPatientsFileDropdownItemOptions<LOCATION_DATA extends GoToPatientFileLocationData> = {
   addToStack?: boolean;
   showAppointmentOutOfSchedule?: boolean;
   patientId: number;
   locationState?: Omit<LocationBackState, 'data'> & { data?: LOCATION_DATA };
};
export const GoToPatientsFileDropdownItem = <
   LOCATION_DATA extends GoToPatientFileLocationData = GoToPatientFileLocationData
>(
   options: GoToPatientsFileDropdownItemOptions<LOCATION_DATA>
): ReactElement => {
   const push = useHistoryPushWithBackAction<PatientFileLocationData>(options.addToStack ?? false);

   return (
      <Dropdown.Item
         testId={'patientsFile'}
         onClick={(hide) => {
            const { data, ...restState } = options.locationState ?? {};
            push(patientPaths.getDataPath(options.patientId), {
               data: {
                  ...(data ?? {}),
                  showAppointmentOutOfSchedule: options.showAppointmentOutOfSchedule ?? false,
               },
               ...restState,
            });
            hide();
         }}
      >
         {patientTranslationKeys.patientsFile}
      </Dropdown.Item>
   );
};
